import {makeStyles} from '@material-ui/core';
import {Colors} from '../../../styles/Colors';
import * as Yup from 'yup';

export type SelectPeriodDialogProps = {
    from: string;
    till: string;
    onUpdate?: (from: string | null, till: string | null) => void;
    isOpen: boolean;
    clickOnClose?: () => void;
};

export const useStyles = makeStyles(() => ({
    modalContainer: {
        '& .MuiDialogContent-root': {
            background: Colors.SmokeBackground,
            height: 'fit-content',
            width: 560,
            padding: 0,
            margin: 0,
            overflowY: 'auto',
            maxHeight: 'calc(90vh - 122px)'
        },

        '& .MuiDialog-paperWidthSm': {
            maxWidth: 'unset',
            maxHeight: 'unset'
        },

        '& .MuiGrid-root:first-child': {
            marginTop: 0,
        },

        '& .MuiPaper-root': {
            width: 576,
        },
        
        '& .MuiFormHelperText-root': {
            right: 0,
            fontSize: '0.75rem',
            fontWeight: 400,
            marginLeft: '4px !important',
            marginRight: '0px !important'
        },
    },

    header: {
        '& .MuiTypography-h6': {
            fontWeight: 700,
            fontSize: 18,
        },
    },

    itemsContainer: {
        padding: 24,
        display: 'flex',
        flexDirection: 'row',

        '& p': {
            fontWeight: 700,
            fontSize: 16,
            lineHeight: '20px',
        },

        '& .MuiFormControl-root': {
            width: 'fit-content',
            height: 56
        },
    },

    form: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        flexGrow: 1,
        width: '100%',
        padding: 0,
        margin: 0,
        overflowX: 'hidden'
    },
    
    boxRow: {
        marginTop: 24,
        display: 'flex',
        alignItems: 'flex-start',
        width: 560,

        '& .Mui-error': {
            fontWeight: 400,
        },
        
        '& > :not(:first-child)': {
            marginLeft: 24,
        },
    },
    
    filter: {
        maxWidth: 302,
        width: '240px !important',
    },

    notLastFilter: {
        marginLeft: 32
    }
}));

export const selectPeriodValidationSchema = Yup.object().shape({
    from: Yup.string()
        .required(),
    to: Yup.string()
        .required()
});
